/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 */

"use strict";

class Card {
    constructor(domNode) {
        this.card = domNode;

        this.buttonPostuler = this.card.querySelector(".card-offer__buttons span");
        this.favoriteButton = this.card.querySelector(".action-bookmark");

        if (this.buttonPostuler) {
            const dataLink = this.buttonPostuler.getAttribute("data-link");
            if (dataLink) {
                this.linkPostuler = atob(dataLink);
                this.buttonPostuler.addEventListener("click", this.onButtonClick.bind(this));
            }
        }

        // Empêcher la navigation quand on clique sur les favoris
        if (this.favoriteButton) {
            this.favoriteButton.addEventListener("click", this.onFavoriteClick.bind(this));
        }
    }

    onButtonClick() {
        window.location.href = this.linkPostuler;
    }

    onFavoriteClick(event) {
        // Empêcher la propagation vers les éléments parents
        event.stopPropagation();
        event.preventDefault();
    }
}

// init cards
const cards = document.querySelectorAll(".card-offer");
cards.forEach((card) => {
    new Card(card);
});
